export default __webpack_public_path__ + "static/media/share-profile-mask.cb41122e.png";